var exports = {
  "kL": "ChannelInvitesTab.module__container___c3Vmdm",
  "wx": "ChannelInvitesTab.module__header___c3Vmdm",
  "h_": "ChannelInvitesTab.module__description___c3Vmdm",
  "GC": "ChannelInvitesTab.module__buttonGroup___c3Vmdm",
  "dc": "ChannelInvitesTab.module__spinnerContainer___c3Vmdm",
  "sJ": "ChannelInvitesTab.module__invitesContainer___c3Vmdm",
  "$h": "ChannelInvitesTab.module__invitesList___c3Vmdm",
  "eu": "ChannelInvitesTab.module__inviteItems___c3Vmdm",
};

module.exports = exports;
